export default function getActiveFilters( filters ) {
    const activeChoicesMap = {};

    // Functie om actieve keuzes toe te voegen aan het object
    const addActiveChoice = (filterKey, value) => {
        if (!activeChoicesMap[filterKey]) {
            activeChoicesMap[filterKey] = [];
        }
        activeChoicesMap[filterKey].push(value);
    };

    // Loop door alle filters en verzamel actieve keuzes
    filters.forEach(filterCategory => {
        filterCategory.filters.forEach(filter => {
            // Check als het een "open_input_range_list" filter is
            if (filter.viewType === "open_input_range_list") {
                const { selectedMinValue, selectedMaxValue, minValue, maxValue } = filter;
                if (selectedMinValue !== minValue || selectedMaxValue !== maxValue) {
                    activeChoicesMap[filter.filterKey] = { min: selectedMinValue, max: selectedMaxValue };
                }
            }

            // Check als het een "range_list" filter is
            if (filter.viewType === "range_list") {
                const { selectedMinValue, selectedMaxValue, minValues, maxValues } = filter;
                if (
                    selectedMinValue !== minValues[0] ||
                    selectedMaxValue !== maxValues[maxValues.length - 1]
                ) {
                    activeChoicesMap[filter.filterKey] = { min: selectedMinValue, max: selectedMaxValue };
                }
            }

            // Check reguliere choices (multi_select, select, etc.)
            filter.choices?.forEach(choice => {
                if (choice.active) {
                    addActiveChoice(filter.filterKey, choice.name);
                }

                // Controleer nested filters binnen choices (zoals modellen binnen merken)
                if (choice.filters) {
                    choice.filters.forEach(subFilter => {
                        subFilter.choices?.forEach(subChoice => {
                            if (subChoice.active) {
                                addActiveChoice(subFilter.filterKey, subChoice.name);
                            }
                        });
                    });
                }
            });

            if (filter.filterKey === "partnervoertuig") {
                const partnerChoice = filter.choices.find(choice => choice.name === "1");
                if (partnerChoice && partnerChoice.active) {
                    activeChoicesMap[filter.filterKey] = partnerChoice.name;
                }
            }
        });
    });

    // Converteer het object naar een array van { filterKey, values }
    const activeChoicesArray = Object.keys(activeChoicesMap).map(filterKey => ({
        filterKey: filterKey,
        values: Array.isArray(activeChoicesMap[filterKey]) && activeChoicesMap[filterKey].length === 1
            ? activeChoicesMap[filterKey][0]
            : activeChoicesMap[filterKey]
    }));

    // Zet de actieve filters om naar een bruikbaar object
    return activeChoicesArray.reduce((acc, item) => {
        acc[item.filterKey] = item.values;
        return acc;
    }, {});
}
